import React from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Button } from '../../shared/ui';
import { getB2bServicePriceCopy } from './b2bServicePriceCopy';
import styles from './B2bServicePriceList.module.css';

export default function B2bServicePriceList({ onRequest }) {
  const { t, i18n } = useTranslation();
  const copy = getB2bServicePriceCopy(i18n.resolvedLanguage || i18n.language);

  return (
    <div className={styles.card}>
      <p className={styles.subtitle}>{copy.subtitle}</p>
      <p className={styles.effective}>{copy.effective}</p>
      <div className={styles.tableWrap}>
        <Table bordered responsive className={styles.table}>
          <thead>
            <tr>
              <th scope="col">{copy.columns.service}</th>
              <th scope="col">{copy.columns.unit}</th>
              <th scope="col">{copy.columns.price}</th>
              <th scope="col">{copy.columns.note}</th>
            </tr>
          </thead>
          <tbody>
            {copy.sections.map(section => (
              <React.Fragment key={section.id}>
                <tr className={styles.sectionRow}>
                  <td colSpan={4}>{section.title}</td>
                </tr>
                {section.rows.map(row => (
                  <tr key={row.id}>
                    <td className={styles.service}>{row.service}</td>
                    <td className={styles.unit}>{row.unit}</td>
                    <td className={styles.price}>{row.price}</td>
                    <td className={styles.note}>{row.note}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </div>
      <div className={styles.conditions}>
        <h3 className={styles.conditionsTitle}>{copy.conditionsTitle}</h3>
        <ol className={styles.conditionsList}>
          {copy.conditions.map(item => (
            <li key={item}>{item}</li>
          ))}
          <li>
            {copy.validThrough}{' '}
            <a className={styles.mailLink} href={`mailto:${copy.salesEmail}`}>
              {copy.salesEmail}
            </a>
          </li>
        </ol>
      </div>
      {onRequest ? (
        <div className={styles.orderRow}>
          <Button
            variant="outline"
            onClick={() => onRequest(`${t('b2bServiceRequestGreeting')}\n\n#ЗаявкаНаСервіс`)}
            className={styles.orderBtn}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              width: '100%',
              minHeight: '56px',
              padding: '14px 20px',
            }}
          >
            <span className={styles.orderLabel}>{t('b2bServiceRequestOrderBtn')}</span>
          </Button>
        </div>
      ) : null}
    </div>
  );
}
